import { Stream } from '@cloudflare/stream-react';
import CloseIcon from '@mui/icons-material/Close';
// import DownloadIcon from '@mui/icons-material/Download';
import {
  Button,
  // CircularProgress,
  Dialog,
  // DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';

// import { useAttachmentDetails } from 'api';
import { FileItem } from 'api/types';
// import { theme } from 'styles';
// import { handleFileDownload } from 'utils';

type Props = {
  file: FileItem;
  open: boolean;
  onClose: () => void;
};

export const DownloadButton = styled(Button)`
  text-transform: none;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  border-radius: 8px;
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.palette.info.main};
`;

export const VideoPreviewModal = ({ file, open, onClose }: Props) => {
  // const handleDownload = async () => {
  //   const { data } = await refetch();
  //   if (data?.data) {
  //     await handleFileDownload({ blobFile: data.data, fileName: file.display_name });
  //   }
  // };

  const renderContent = () => {
    return (
      <Stream
        key={file.id}
        controls
        autoplay
        poster={`https://customer-${process.env.REACT_APP_CLOUDFLARE_STREAM_ACCOUNT_ID}.cloudflarestream.com/${file.file_url.video_uid}/thumbnails/thumbnail.jpg`}
        src={file.file_url.video_uid}
        onLoadedData={() => null}
        height="100%"
        width="100%"
        responsive={false}
      />
    );
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { width: '100%', maxWidth: 800 } }}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 1,
        }}
      >
        {file.display_name}
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{ p: file.type === 'image' ? 0 : 2, display: 'flex', justifyContent: 'center' }}
      >
        {renderContent()}
      </DialogContent>
      {/* <DialogActions sx={{ px: 2, pb: 2 }}>
        <DownloadButton
          startIcon={<DownloadIcon />}
          onClick={handleDownload}
          disabled={isLoading}
          style={{
            height: '48px',
            padding: '0 32px',
            backgroundColor: theme.palette.info.main,
            color: '#fff',
            borderRadius: '8px',
            fontWeight: 400,
            textTransform: 'none',
          }}
        >
          Download file
        </DownloadButton>
      </DialogActions> */}
    </Dialog>
  );
};
